<div>
    <h6 class="ap-green mt-1">{{header1}}</h6>
    <div class="text-danger">{{header2}}</div>
    <div>{{header3}}</div>
    <div>
        <dx-data-grid #suspectListGrid style="width: 100%" [dataSource]="suspectList" [columnAutoWidth]="true"
            [allowColumnReordering]="true" [wordWrapEnabled]="false" showBorders="true"
            (onCellHoverChanged)="onCellHoverChanged($event)">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)"
                        text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxi-column dataField="dunsNumber" caption="DUNS Number" cssClass="column-group-sub-header">
                <dx-tooltip target="" showEvent="mouseenter" hideEvent="mouseleave">
                    <div *dxTemplate="let data of 'content'"> </div>
                </dx-tooltip>
            </dxi-column>
            <dxi-column dataField="dataSource" caption="Data Source" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="companyName" caption="Company" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="address" caption="Address" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="city" caption="City" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="countyPrefecture" caption="County Prefecture"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="province" caption="State/Province" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="zipCode" caption="Post Code" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="countryid" caption="Country" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="phoneNumber" caption="Phone Number" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="territory" caption="US LB Territory" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="apRefSite" caption="Closest Selected Plant"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="refMiles" caption="Closest Selected Plant dist miles"
                cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="closestSelectedPlantDistDm" caption="Closest Selected Plant dist km"
                cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="apSite" caption="Closest AP Site" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="miles" caption="Closest AP Distance miles" cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="closestAPDistanceKm" caption="Closest AP Distance km"
                cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="altCo" caption="AP alt Plant" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="altMiles" caption="AP alt Distance mi" cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="apAltDistanceKm" caption="AP alt Distance km" cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="apToAltAPDistanceMi" caption="AP to altAP Distance mi"
                cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="apToAltAPDistanceKm" caption="AP to altAP Distance km"
                cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="altNonAPCo" caption="NonAP Plant" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="altNonAPMiles" caption="NonAP mi" cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="nonAPkm" caption="NonAP km" cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="apAdvg" caption="AP Distance Fav. miles" cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="apDistanceFavKm" caption="AP Distance Fav. km" cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column dataField="apDistanceFav" caption="Is 'AP Distance Fav.' positive?"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="exclude" caption="Exclude" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="excludeComment" caption="Exclude Comment"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="custComment" caption="Cust Comment" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="locationType" caption="Location Type"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="siteRevenueDollars" caption="Site Revenue"
                cssClass="column-group-sub-header" [format]="{ style: 'currency', currency: 'USD', useGrouping: true }"></dxi-column>
            <dxi-column dataField="isSiteRevenueOver1MM" caption="Is Site Revenue Over $1MM"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="employeeCountTotal" caption="Employee Count Total"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="employeeCountHere" caption="Employee Count Here"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="isSmallBusiness" caption="Is Small Business"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="squareFootage" caption="Square Footage"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="yearStarted" caption="Year Started" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="lineOfBusinessPerDB" caption="Line Of Business Per D&B"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="isGasUserDisplayText" caption="Is Gas User"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="isAPAccountDisplayText" caption="Is AP Account"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="isCompetitorAccountDisplayText" caption="Is Competitor Account"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="competitorName" caption="Competitor Name"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="globalIndustrySegment" caption="Global Industry Segment"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="siC2Desc" caption="SIC2 Desc" cssClass="column-group-sub-hea~der"></dxi-column>
            <dxi-column dataField="siC8" caption="SIC8" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="siC8Desc" caption="SIC8 Desc" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="naicsCode" caption="NAICS Code" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="naicsCodeDescription" caption="NAICS Description"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="contact1" caption="Contact1" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="contact2" caption="Contact2" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="contact3" caption="Contact3" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="contact4" caption="Contact4" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="yNProbability" caption="Yes/No Probability"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="mtpdN2" caption="Relative  LIN Volume by 'mva'"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="mtpdO2" caption="Relative  LOX Volume by 'mva'"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="mtpdAr" caption="Relative  LAR Volume by 'mva'"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="mtpdCO2" caption="Relative  CO2 Volume by 'mva'"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="mtpdN2NoAP" caption="Relative  LIN Volume by 'mva' no AP"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="mtpdO2NoAP" caption="Relative  LOX Volume by 'mva' no AP"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="mtpdArNoAP" caption="Relative  LAR Volume by 'mva' no AP"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="mtpdCO2NoAP" caption="Relative  CO2 Volume by 'mva' no AP"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="siteID" caption="SiteID" cssClass="column-group-sub-header"></dxi-column>
        </dx-data-grid>
    </div>
</div>